import { Component, HostListener, OnInit } from '@angular/core';
import { GiftComponent } from './components/gift/gift.component';
import { PlacesComponent } from './components/places/places.component';
import { PhraseComponent } from './components/phrase/phrase.component';
import { MessageComponent } from './components/message/message.component';
import { GreetingComponent } from './components/greeting/greeting.component';
import { FrontPageComponent } from './components/front-page/front-page.component';
import { CountDownComponent } from './components/count-down/count-down.component';
import { CommonModule } from '@angular/common';
import { HomeComponent } from "./components/home/home.component";
import { RouterOutlet } from '@angular/router';

@Component({
   selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  isMobile: boolean = false;

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    const width = window.innerWidth;
    this.isMobile = width <= 600; // Aquí puedes ajustar el tamaño máximo permitido para pantalla móvil
  }
  
  
}
